import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "mb-4 text-4xl" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-left border rounded table-auto"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "border-t border-b bg-primary-dark" }, [
    /*#__PURE__*/_createVNode("th", { class: "p-6 py-4" }, "Event ID"),
    /*#__PURE__*/_createVNode("th", { class: "p-6 py-4" }, "Title"),
    /*#__PURE__*/_createVNode("th", { class: "p-6 py-4" }, "Phase"),
    /*#__PURE__*/_createVNode("th", { class: "p-6 py-4" }, "Category"),
    /*#__PURE__*/_createVNode("th", { class: "p-6 py-4" }, "Prerequisites"),
    /*#__PURE__*/_createVNode("th", { class: "p-6 py-4" }, "Time")
  ])
], -1)
const _hoisted_5 = { class: "p-6 py-4" }
const _hoisted_6 = { class: "p-6 py-4" }
const _hoisted_7 = { class: "p-6 py-4 capitalize" }
const _hoisted_8 = { class: "p-6 py-4 capitalize" }
const _hoisted_9 = { class: "p-6 py-4 max" }
const _hoisted_10 = { class: "p-6 py-4" }
const _hoisted_11 = {
  key: 1,
  class: ""
}
const _hoisted_12 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.topic.title), 1),
    (!_ctx.loading && _ctx.events && _ctx.events.length)
      ? (_openBlock(), _createBlock("table", _hoisted_3, [
          _hoisted_4,
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.events, (event, eventIndex) => {
              return (_openBlock(), _createBlock("tr", {
                key: eventIndex,
                class: "pb-8 border-b bg-primary-dark"
              }, [
                _createVNode("td", _hoisted_5, [
                  _createVNode("button", {
                    class: "p-1 mr-2 text-black border rounded focus:outline-none bg-highlight",
                    onClick: ($event: any) => (_ctx.handleEventClick(event.name))
                  }, _toDisplayString(event.name), 9, ["onClick"])
                ]),
                _createVNode("td", _hoisted_6, _toDisplayString(event.title), 1),
                _createVNode("td", _hoisted_7, _toDisplayString(_ctx.formatPhase(event.phase)), 1),
                _createVNode("td", _hoisted_8, _toDisplayString(_ctx.formatCategory(event.category)), 1),
                _createVNode("td", _hoisted_9, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(event.prerequisites, (prereq, preReqIndex) => {
                    return (_openBlock(), _createBlock("span", {
                      class: "p-1",
                      key: preReqIndex
                    }, _toDisplayString(prereq), 1))
                  }), 128))
                ]),
                _createVNode("td", _hoisted_10, _toDisplayString(event.hours), 1)
              ]))
            }), 128))
          ])
        ]))
      : (_ctx.loading)
        ? (_openBlock(), _createBlock("div", _hoisted_11, "Loading event data...."))
        : (_openBlock(), _createBlock("div", _hoisted_12, "No events for this topic"))
  ]))
}